import React, { useContext } from "react";
import styles from "styles/FAQs.module.scss";
import { useTranslation } from "react-i18next";
import Spacer from "components/Spacer";
import clsx from "clsx";
import { NextPage } from "next";
import { Header, HeaderVariant } from "../components/Header";
import nftInstructions4 from "../public/faqs/nft-instructions-4.png";
import nftInstructions5 from "../public/faqs/nft-instructions-5.png";
import Image from "next/image";
import { Meta } from "../components/Meta";
import { MINT_FEE_NUMBER } from "../utils/constants";
import { MediaQueryContext } from "../context/mediaQuery/context";

const FAQs: React.FC<NextPage> = () => {
  const { t } = useTranslation();
  const {
    state: { tablet },
  } = useContext(MediaQueryContext);

  return (
    <>
      <Meta title={t("faqs.text")} />
      <div className={clsx(styles.container, "column ai-center")}>
        <Header variant={HeaderVariant.dark} />
        <Spacer height={59} className={"hideOnTablet"} />
        <Spacer height={18} className={"hideOnDesktop"} />
        <div className={styles.headline}>{t("faqs.weHaveAnswers")}</div>
        <Spacer height={100} className={"hideOnTablet"} />
        <Spacer height={48} className={"hideOnDesktop"} />
        <div className={"rowDesktopColumnTablet"}>
          <div className={styles.panel}>
            <div className={styles.question}>{t("faqs.whatIs")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.whatIsAnswerP1"),
              }}
            />

            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.whatxNFTs")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.whatxNFTsAnswerP1"),
              }}
            />
            <Spacer height={24} />
            <Image
              placeholder={"blur"}
              src={nftInstructions4}
              width={364}
              height={487}
              alt={"xNFT"}
              layout={tablet ? "responsive" : "fixed"}
            />

            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.whatGetting")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.whatGettingAnswerP1"),
              }}
            />

            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.whySpecial")}</div>
            <Spacer height={24} />
            <div
              dangerouslySetInnerHTML={{
                __html: t("faqs.whySpecialAnswerP1"),
              }}
              className={styles.p}
            />

            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.howMuchCost")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.howMuchCostAnswerP1", { fee: MINT_FEE_NUMBER }),
              }}
            />
          </div>

          <Spacer width={136} className={"hideOnTablet"} />
          <Spacer height={82} className={"hideOnDesktop"} />
          <div className={styles.panel}>
            <div className={styles.question}>{t("faqs.howCreate")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.howCreateAnswerP1"),
              }}
            />
            <Spacer height={6} />
            <Image
              placeholder={"blur"}
              src={nftInstructions5}
              width={457.24}
              height={487}
              alt={"NFT"}
              layout={tablet ? "responsive" : "fixed"}
            />
            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.howGeRoyalties")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.howGeRoyaltiesAnswerP1"),
              }}
            />

            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.canISell")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.canISellAnswerP1"),
              }}
            />
            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={82} className={"hideOnDesktop"} />

            <div className={styles.question}>{t("faqs.verifiedProperty")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.verifiedPropertyAnswerP1"),
              }}
            />
            <Spacer height={150} className={"hideOnTablet"} />
            <Spacer height={64} className={"hideOnDesktop"} />
            <div className={styles.question}>{t("faqs.whatIsLicense")}</div>
            <Spacer height={24} />
            <div
              className={styles.p}
              dangerouslySetInnerHTML={{
                __html: t("faqs.whatIsLicenseAnswerP1"),
              }}
            />
            <Spacer height={18} />
          </div>
        </div>
        <Spacer height={200} className={"hideOnTablet"} />
        <Spacer height={100} className={"hideOnDesktop"} />
      </div>
    </>
  );
};

export default FAQs;
